"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourlyForecastNew = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const material_1 = require("@mui/material");
const helpers_1 = require("../../helpers/helpers");
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const WeatherIcon_1 = __importDefault(require("./WeatherIcon"));
const ForecastList = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  flex-basis: 54%;
  flex-shrink: 0;

  @media (orientation: portrait) {
    flex-shrink: 1;
  }

  .weather-icon {
    height: 5vmin;

    svg {
      height: 100%;
      width: 100%;
    }
  }
`;
const ForecastListItem = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  flex-direction: column;
  height: 22vmin;

  @media (orientation: portrait) {
    height: auto;
  }
`;
const Time = styled_components_1.default.div `
  font-size: 3vmin;
  font-weight: 400;

  @media (orientation: portrait) {
    font-size: 3vmin;
  }
`;
const Temperature = styled_components_1.default.div `
  font-size: 3.5vmin;
  font-weight: 400;

  @media (orientation: portrait) {
    font-size: 3vmin;
  }
`;
const HourlyForecastNew = (props) => {
    const { timezone, forecast } = props;
    const timeNow = helpers_1.Helpers.convertDateToTimezone(new Date().toISOString(), timezone, { hour: '2-digit', hour12: false });
    const renderForecast = () => 
    // eslint-disable-next-line consistent-return
    forecast.map((day, index) => {
        const forecastTime = helpers_1.Helpers.convertHourToTimezone(day.time, timezone);
        if (index === 0) {
            if (parseInt(helpers_1.Helpers.convertDateToTimezone(day.time, timezone, {
                hour: '2-digit',
                hour12: false,
            }), 10) -
                parseInt(timeNow, 10) <
                0) {
                return '';
            }
        }
        if (index <= 5) {
            return (react_1.default.createElement(ForecastListItem, { key: (0, react_uid_1.uid)(day) },
                react_1.default.createElement(Time, null,
                    " ",
                    forecastTime === '24:00' ? '0:00' : forecastTime,
                    " "),
                react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(WeatherIcon_1.default, { symbol: day.symbol })),
                react_1.default.createElement(Temperature, null,
                    day.temperature,
                    "\u00B0")));
        }
    });
    return react_1.default.createElement(ForecastList, { asSlide: props.asSlide },
        " ",
        renderForecast(),
        " ");
};
exports.HourlyForecastNew = HourlyForecastNew;
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.HourlyForecastNew);
